import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

export default class Pagination extends PureComponent {
  render() {
    const { getList, links = [], location: { search } = {} } = this.props;
    return (
      <ul className="pagination pagination-sm">
        {links?.map?.(
          link =>
            link.url && (
              <li className="page-item" key={link.label}>
                <Link
                  className="page-link"
                  dangerouslySetInnerHTML={{ __html: link.label }}
                  onClick={() => getList?.({
                    ...Object?.fromEntries?.(new URLSearchParams(search)),
                    page: link.label,
                  })}
                  to={link.url}
                />
              </li>
            ),
        )}
      </ul>
    );
  }
}
